module.exports = __webpack_public_path__ + "static/media/Sio_login_NoOutline.afa1a463.png";